import { useEffect } from 'react';
import styled from 'styled-components';

const ScrollToTopButton = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const button = document.getElementById('scrollToTopButton');
      if (button) {
        if (scrollY > 100) {
          button.style.display = 'flex';
        } else {
          button.style.display = 'none';
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 페이지 상단으로 스크롤하는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ToTopButtonBox id="scrollToTopButton">
      <ToTopButton onClick={scrollToTop}>
        <img src="/assets/images/arrow/top-button.svg" alt="" />
      </ToTopButton>
    </ToTopButtonBox>
  );
};

export default ScrollToTopButton;

const ToTopButtonBox = styled.div`
  position: fixed;
  position: fixed;
  right: 24px;
  bottom: 88px;
  cursor: pointer;
  z-index: 997;
  pointer-events: none;
`;
const ToTopButton = styled.div`
  cursor: pointer;
  pointer-events: auto;
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  background-color: #fff;
  backdrop-filter: blur(6px);

  box-shadow: 0px 4px 15px 0px #8d95a340;
  display: flex;
  justify-content: center;
  align-items: center;
`;
